import { requestConst } from '../consts';

export function categories(state = {}, action) {
    switch (action.type) {
        case requestConst.CATEGORIES_REQUEST:
            return { getting: true };
        case requestConst.CATEGORIES_SUCCESS:
            return { categories: action.categories };
        case requestConst.CATEGORIES_FAILURE:
            return {};
        default:
            return state;
    }
}
